export const getDurationTimeString = (ts) => {
	const dt = new Date(ts);
	let hours = dt.getHours();
	hours = hours < 10 ? `0${hours}` : hours;
	let minutes = dt.getMinutes();
	minutes = minutes < 10 ? `0${minutes}` : minutes;
	return `${hours} hours ${minutes} minutes`;
}

export const get24hTimeString = (ts) => {
	const dt = new Date(ts);
	let hours = dt.getHours();
	hours = hours < 10 ? `0${hours}` : hours;
	let minutes = dt.getMinutes();
	minutes = minutes < 10 ? `0${minutes}` : minutes;
	return `${hours}:${minutes}`;
}

export const getFormattedDate = (dt) => {
	if(!dt) {return '';}
	if(!(dt instanceof Date)) {
		dt = new Date(dt);
		if(!dt || isNaN(dt)) {
			return;
		}
	}
	let day = dt.getDate();
	day = day < 10 ? '0'+day : day;
	let month = dt.getMonth()+1;
	month = month < 10 ? '0'+month : month;
	const year = dt.getFullYear();
	return day+'/'+month+'/'+year;
}